import 'isomorphic-fetch';
import { fetchResource } from './fetch-resource';

import { API } from '../constants';

/**
 * AltInvestment API service
 */
class AltInvestmentService {
  /**
   * Retrieves products for listing in the marketplace
   * @example
   * getAltInvestmentsForListing('someJwt').then(res => { return res.data }).then(...)
   * @returns {Promise} Returns a promise containing the result in json format.
   */
  static gePublishedtAltInvestments = (jwt) => {
    const requestConfig = {
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
        'authorization': `bearer ${ jwt }`,
      },
      method: 'GET',
    };

    return fetchResource(`${ API.ALTERNATIVE_INVESTMENTS }?published=true&limit=5000`, requestConfig);
  }

  /**
   * Retrieves products for listing in the marketplace filtered by a specific lister id.
   * @example
   * getAltInvestmentsForListing('someJwt').then(res => { return res.data }).then(...)
   * @returns {Promise} Returns a promise containing the result in json format.
   */
  static getPublishedAltInvestmentsByListerId = (jwt, listerId) => {
    const requestConfig = {
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
        'authorization': `bearer ${ jwt }`,
      },
      method: 'GET',
    };

    return fetchResource(`${ API.ALTERNATIVE_INVESTMENTS }?published=true&lister_id=${ listerId }`, requestConfig);
  }

  /**
   * Retrieves products by a collection of Ids
   * @example
   * getAltInvestmentsForListing('someJwt' ['id1','id2']).then(res => { return res.data }).then(...)
   * @returns {Promise} Returns a promise containing the result in json format.
   */
  static getAltInvestmentsByIdCollection = (jwt, productIdCollection = []) => {
    function onlyUnique(value, index, self) { 
      return self.indexOf(value) === index;
    }
    const ids = productIdCollection && productIdCollection?.filter(onlyUnique).join(',');
    const requestConfig = {
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
        'authorization': `bearer ${ jwt }`,
      },
      method: 'GET',
    };

    return fetchResource(`${ API.ALTERNATIVE_INVESTMENTS }?_id=(${ ids })&limit=1000`, requestConfig);
  }

  /**
   * Retrieve product for the id specified
   * @param {Token} jwt 
   * @param {product id} id the product id for the product to get.
   * @returns {Promise} Returns a promise containing the result in json format.
   */
  static getAltInvestmentById = (jwt, id) => {
    const requestConfig = {
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
        'authorization': `bearer ${ jwt }`,
      },
      method: 'GET',
    };
    return fetchResource(`${API.ALTERNATIVE_INVESTMENTS}?_id=${id}`, requestConfig);
  }
}

export default AltInvestmentService;
